import React, { Dispatch, SetStateAction } from 'react';
import { StyleSheet, View, ScrollView } from 'react-native';
import isMobile from '../../../../../IsMobile';
import SelectionModal from '../../../../../SelectionModal';
import Colors from '../../../../../../constants/Colors';
import { TemplateGroup } from '../../../../../../constants/Types';
import Option from '../../IssueList/components/IssueRow/components/Option';

interface TemplateGroupListProps {
  templateGroups: TemplateGroup[],
  templateGroupDropdownShown: boolean,
  setTemplateGroupDropdownShown: Dispatch<SetStateAction<boolean>>,
  selectedTemplateGroupId: string,
  setSelectedTemplateGroupId: Dispatch<SetStateAction<string>>,
}

const TemplateGroupList = ({
  templateGroups, templateGroupDropdownShown, selectedTemplateGroupId, setSelectedTemplateGroupId,
  setTemplateGroupDropdownShown,
}: TemplateGroupListProps) => {
  const List = () => <View testID='template-group-list'>
    {templateGroups
      ?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name?.toLowerCase()
        .localeCompare(b.Name?.toLowerCase()))
      ?.map((group: TemplateGroup, index: number) => <Option
        key={`template_group_dropdown_option_${group.ButtonPrototypeGroupId}`}
        text={group.Name}
        onPress={() => {
          setSelectedTemplateGroupId(group.ButtonPrototypeGroupId);
          setTemplateGroupDropdownShown(false);
        }}
        selected={group.ButtonPrototypeGroupId === selectedTemplateGroupId}
        testID={`template-group#${index + 1}`}
      />)}
  </View>;

  return isMobile ? <SelectionModal
    listContent={<List />}
    title='Select template group'
    isVisible={templateGroupDropdownShown}
    hide={() => setTemplateGroupDropdownShown(false)}
  /> : (templateGroupDropdownShown && <ScrollView
    nestedScrollEnabled
    style={styles.containerWeb}
  >
    <List />
  </ScrollView>);
};

const styles = StyleSheet.create({
  containerWeb: {
    maxHeight: 180,
    alignSelf: 'stretch',
    marginTop: 4,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: '#FFF',
  },
});

export default TemplateGroupList;
